/**
 * Product Context
 *
 * Manages product-related state for the Items feature.
 * Uses components/types.Product for compatibility with presentation layer.
 * Replaces product-related state from old AppContext.
 */

import { createContext } from "react";
// Import from components/types for compatibility with vendor-dashboard components
import { Product } from "@semo/shared-product";

export interface ProductContextType {
  products: Product[];
  isLoading: boolean;
  error: Error | null;
  addProduct: (product: Omit<Product, "id">) => Promise<void>;
  updateProduct: (id: string, updates: Partial<Product>) => Promise<void>;
  removeProduct: (id: string) => Promise<void>;
  refreshProducts: () => Promise<void>;
  updateSupplierSettings: (
    id: string,
    settings: { price?: number; isSelling?: boolean },
  ) => Promise<void>;
}

export const ProductContext = createContext<ProductContextType | undefined>(
  undefined,
);
ProductContext.displayName = "ProductContext";
